var _defs, _path, _ellipse, _rect, _path2, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect4, _polygon, _polygon2, _rect5, _rect6, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSessionTimeout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff897a;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13{stroke-width:0px;}.cls-2{fill:#d0e4ff;}.cls-3{fill:#00497f;}.cls-4{fill:#fafafc;}.cls-5{fill:#00325a;}.cls-6{fill:#e8f1ff;}.cls-7{fill:#060633;}.cls-8{fill:#0071f3;}.cls-9{fill:#fff;}.cls-10{fill:#ffcf4d;}.cls-11{fill:#ff7247;}.cls-12{fill:#f9a58f;}.cls-13{fill:#ffad8c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M293.52,962.09s-238.83-100.24-120.4-350.66c118.43-250.42-85.42-422.75,144.51-519.45,125.41-52.74,196.44,72.09,404.07-14.12,207.63-86.21,361.66-26.14,458.86,3.32,97.21,29.45,300.73-146.21,445.23,10.81,159.34,173.16-20.36,331.02,98.97,526.24,176.1,288.07-126.41,380.06-126.41,380.06l-1304.83-36.18Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 970.39,
    cy: 973.84,
    rx: 740.97,
    ry: 80.34
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 870.98,
    y: 819.76,
    width: 180.44,
    height: 169.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M515.54,177.78h903.9c12.13,0,21.98,9.85,21.98,21.98v618.34c0,12.13-9.85,21.98-21.98,21.98h-903.9c-12.13,0-21.98-9.85-21.98-21.98V199.76c0-12.13,9.85-21.98,21.98-21.98Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 517.71,
    y: 195.33,
    width: 898.62,
    height: 594.87
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 807.14,
    y: 973.09,
    width: 308.12,
    height: 36.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M761.17,201.57c-43.13,98.63-130.07,49.71-137.49,143.47-8.47,107.08-75.89,74.27-52.24,149.3,9.3,29.51,42.91,44.52,73.19,50.9,30.28,6.38,61.84,5.74,91.74,13.72,30.41,8.11,58.24,24.91,89.2,30.57,42.86,7.83,178.65,22.18,159.12-16.77-49.17-98.05,55.53-85.25,58.71-145.57,3.41-64.57-21.39-90.59-21.4-173.76-.01-55.92-29.58-88.46-53.07-106.34-53.33-40.61-169.54-32.92-207.76,54.49Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1065.11,585.58s28.02,79.78,41.63,81.86c9.53,1.46,85.34-127.49,85.34-127.49l32.29,31.7s-59.51,188.49-131.24,188.46c-46.26-.02-115.51-119.04-113.47-123.54,2.04-4.5,59.02-53.75,59.02-53.75l26.42,2.76Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1078.58,591.93l-6.4,4.39-2.51,1.72-49.5,33.89-1.59,1.08s.08.57.17,1.61h0c.53,5.94,1.23,27.33-12.47,46.33-.27.37-.55.75-.84,1.12-6.95,9.21-17.42,17.78-33.04,23.65l-14.39,84.49h-236.8c.34-40.53.42-102.45-1.77-135.91h0c-.37-5.69-.81-10.53-1.33-14.32-.9-6.71-2.05-10.11-3.49-8.84-17.32,15.37-60.86-27.96-81.83-50.93-6.84-7.49-11.28-12.81-11.63-13.24l-.02-.02h-.01s6.51-9.68,16.44-23.34c.01-.01.02-.01.02-.02,21.49-29.54,58.98-77.66,81.16-86.52,48.91-19.49,103.33-16.8,122.84-14.98h.01c4.77.43,7.46.83,7.46.83l59.65,3.37s5.93,1.04,15.17,3.04c20.94,4.55,58.84,14.01,82.83,27.25,2.22,1.22,4.32,2.49,6.28,3.77,2.29,1.51,4.4,3.06,6.26,4.66,20.18,17.27,59.32,106.93,59.32,106.93Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M990.65,288.73s9.23-11.3,15.07-5.74c14.89,14.17-4.25,29.08-15.37,31.6l.3-25.86Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M903.64,131.7c-49.76-1.71-93.65,34.74-101.2,83.95-2.49,16.18-.91,31.94,3.87,46.34,10.17,35.71,18.66,64.52,30.63,86.06,12.14,21.85,16.15,47.27,10.17,71.53l-5.54,22.48c28.39,17.92,49,24.4,62.25,26.48,9.72,1.53,18.7-5.5,19.68-15.28l5.83-58.34h0c62.82-1.2,65.99-116.6,69.38-150.47h-.1c.18-1.25.35-2.52.48-3.8,5.66-56.68-37.59-106.96-95.44-108.96Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M885.89,230.71c-19.4,18.77-39.85,37.03-55.15,59.18-1.69,2.43-13.78,20.81-11.07,23.33-14.79-13.76-23.23-32.94-30.05-51.96-11.83-32.96-3.69-70.33,17.53-97.63,20.97-26.99,52.84-38.91,86.54-38.3,36.14.66,74.04,16.6,92.97,48.7,17.76,30.14,15.15,65.74,14.18,99.28,1.09-37.65-46.4-70.56-75.2-86.77.84.47-25.63,30.06-27.03,31.5-4.14,4.28-8.4,8.48-12.72,12.65Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M833.64,292.64c-1.27-3.35-3.81-6.06-6.98-7.73-6.54-3.43-18.25-7.63-27.34-.19-13.33,10.91,7.84,45.46,33.53,31.91,0,0,7.57-6.2.79-23.99Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M974.23,288.03c.93-4.69-2.11-9.24-6.8-10.17-4.69-.93-9.24,2.12-10.17,6.8-.93,4.69,2.11,9.24,6.8,10.17,4.69.93,9.24-2.11,10.17-6.8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M892.05,289.03c.93-4.69-2.11-9.24-6.8-10.17-4.69-.93-9.24,2.11-10.17,6.8-.93,4.69,2.12,9.24,6.8,10.17,4.69.93,9.24-2.12,10.17-6.8Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M867.7,273.62c-1.03-.09-2.01-.62-2.64-1.53-1.14-1.63-.73-3.87.9-5.01.49-.34,12.23-8.27,28.2-6.18,1.97.26,3.36,2.06,3.1,4.03-.26,1.97-2.23,3.37-4.03,3.1-13.3-1.73-23.06,4.88-23.16,4.95-.72.5-1.56.7-2.37.63Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M953.78,266.21c-.98-.33-1.81-1.08-2.21-2.11-.72-1.85.2-3.94,2.06-4.65.55-.21,13.7-5.2,28.85.67,1.86.72,2.78,2.8,2.06,4.65-.71,1.86-2.87,2.77-4.65,2.06-12.53-4.85-23.55-.71-23.67-.67-.82.31-1.68.31-2.45.05Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M952.93,345.48l-48.1-.45s14.78,15.04,27.68,15.87c12.9.83,20.42-15.43,20.42-15.43Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1292.04,524.87c-2.09-8.8-19.16-12.69-19.64-21.67-1.96-4.83-3.84-9.69-5.46-14.65-1-3.06-1.56-6.1-1.89-9.14-8.31,5.36-22.36,12.63-22.36,12.63,0,0,28.35-30.81,20.15-33.29-8.2-2.48-28.72,19.51-38.54,30.56-31.65,35.6-32.21,50.64-32.21,50.64l15.31,35.04c23.1-1.82,56.75-18.89,74.63-30.42-2.69-4.57,11.25-14.53,10.02-19.69Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1202.55,
    y: 168.09,
    width: 117.66,
    height: 607.79,
    transform: "translate(184.23 -336.47) rotate(16.38)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1381.02 69.96 1290.61 163.83 1403.5 197 1381.02 69.96"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1381.02 69.96 1335.81 116.89 1392.26 133.48 1381.02 69.96"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1108.88,
    y: 757.54,
    width: 117.66,
    height: 66.46,
    transform: "translate(270.3 -297.13) rotate(16.38)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1120.86,
    y: 735.84,
    width: 117.66,
    height: 28.29,
    transform: "translate(259.29 -302.16) rotate(16.38)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1336.4,456.96s-39.54,1.14-40.08,6.7c-.55,5.57,30.26,11.68,29.76,11.76-.5.08-33.64-.96-36.94,6.15-3.3,7.11,25.47,11.46,25.47,11.46,0,0-24.02-2.16-26,2.83-1.99,4.99,19.24,8.5,18.86,10.53-.38,2.03-17.07-2.47-19.81,3.62-2.73,6.09,31.84,17.84,37.68,13.06,5.84-4.78,2.34-11.65,2.34-11.65,0,0,8.92-9.08,6.54-15.65,0,0,6.97-15.95.61-20.36,0,0,11.27-10.26,1.57-18.45Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M749.59,536.03s-2.97,9.09-7.76,24.47c-5.88,18.8-14.48,46.99-23.71,79.46-1.18,4.13-2.37,8.35-3.56,12.63-12.16,43.5-24.95,93.12-33.76,137.61h-93.26c6.12-67.35,33.01-166.83,43.64-204.37h0c.59-2.08,1.11-3.95,1.61-5.63,1.73-6.05,2.74-9.43,2.74-9.43l61.13-18.62h.02s52.9-16.11,52.9-16.11Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M621.14,566.92s27.76,72.52,115.61,92.13l31.63-166.29-94.83,32.11-52.41,42.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionTimeout);
export default __webpack_public_path__ + "static/media/session-timeout.c43540f5b2465aff1c569a67a5f57f99.svg";
export { ForwardRef as ReactComponent };